import React from 'react';

// Pie de contexto del detalle (patrón ③): ocurrencias, ítem afectado, actor, timestamp
// de plataforma. Texto chico atenuado, separado por un filete.
export function DetailFooter({children}) {
    if (!children) return null;
    return <div className="ald-footer">{children}</div>;
}
